import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { track } from "@/lib/journey/tracker";

/**
 * Session 45 · WhatsApp-Kontaktbutton (unten rechts, direkt über Sticky-CTA)
 *
 * Offizieller Click-to-Chat-Link (wa.me) – kein Plugin, keine externe SDK.
 * Design integriert in Picturebox24-Farbwelt (Dunkelblau + Gold, dezenter WhatsApp-Akzent).
 * Positioniert rechts unten, visuell untergeordnet direkt oberhalb des Sticky-CTA
 * „Wunschtermin prüfen" – Kontakt- und Buchungsoptionen werden als Gruppe wahrgenommen.
 */

// Platzhalter-Nummer, wird noch durch die finale ersetzt.
// Format: +49 (kein Plus, keine führende 0, keine Leerzeichen) – aktuell +49 156 78575025
const WHATSAPP_NUMBER = "4915678575025";
const WHATSAPP_MESSAGE = "Hallo, ich interessiere mich für eine Fotobox von Picturebox24 und habe noch eine Frage.";

function buildLink() {
  const msg = encodeURIComponent(WHATSAPP_MESSAGE);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`;
}

export default function WhatsAppButton() {
  const { pathname } = useLocation();

  // Nicht auf Admin / POS anzeigen
  if (pathname.startsWith("/admin") || pathname.startsWith("/interne-buchung")) return null;

  const handleClick = () => {
    try { track({ id: "whatsapp_contact_click", label: "WhatsApp-Kontakt angeklickt" }, { path: pathname }); } catch (_) { /* noop */ }
  };

  return (
    <a
      href={buildLink()}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      aria-label="Frage per WhatsApp stellen"
      data-testid="whatsapp-button"
      className="fixed z-40 right-6 bottom-20 group inline-flex items-center gap-2 px-3 py-2 bg-ink-900/95 backdrop-blur-md border border-gold/40 hover:border-gold text-cream/90 hover:bg-ink-800 rounded-full shadow-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-ink-950"
      style={{ marginBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <MessageCircle className="h-3.5 w-3.5 text-[#25D366] shrink-0" strokeWidth={1.7} />
      <span className="text-[0.62rem] uppercase tracking-[0.2em] font-medium whitespace-nowrap">
        <span className="hidden sm:inline">Frage per WhatsApp stellen</span>
        <span className="sm:hidden">WhatsApp</span>
      </span>
    </a>
  );
}
